import _ from 'underscore';

const getAccountInactiveReasonsContainsQuery =
  valueArr => `AccountInactiveReasons/any(r:r/Reason eq Enum.AccountInactiveReasonCode'${valueArr[0]}')`;
const getAccountInactiveReasonsDoesNotContainQuery =
  valueArr => `AccountInactiveReasons/all(r:r/Reason ne Enum.AccountInactiveReasonCode'${valueArr[0]}')`;

export function updateEntitySchemaForAccountInactiveReasons(entitySchema, schemaI18nCampaign, permissions) {
  const enumValues = [
    'PausedDueToSystemIssue',
    'PausedZeroBalance',
    'PausedNoValidIO',
    'Processing',
    'PendingPaymentMethod',
    'PendingNewCustomer',
    'Inactive',
    'Hold',
    'Deleted',
    'AccountMissingVATId',
    'AccountVerificationHold',
    ...permissions.dynamic && permissions.dynamic.TSTMasterDataMissingNotification ? [
      'AccountTradeScreeningDataIssue',
      'AccountTradeScreeningUnderReview',
      'BillToCustomerTradeScreeningDataIssue',
      'BillToCustomerTradeScreeningUnderReview',
      'AccountTradeScreeningLicenseRequired',
      'BillToCustomerTradeScreeningLicenseRequired',
    ] : [],
  ];

  _.extend(entitySchema.properties, {
    AccountInactiveReasons: {
      name: 'AccountInactiveReasons',
      title: schemaI18nCampaign.property('Account', 'AccountInactiveReasons'),
      localized: _.object(enumValues, _.map(enumValues, value => schemaI18nCampaign.value('AccountInactiveReason', 'Reason', value))),
      chooseType: 'select',
      operators: ['contains', 'doesnotcontain'],
      enum: enumValues,
      enumValueMap: {}, // just a placeholder so page will not break because of undefined.
      type: 'string',
      property: 'AccountInactiveReasons',
      originalProperty: 'AccountInactiveReasons',
      filterable: true,
    },
  });

  return entitySchema;
}

export function updateOdataOptionsForAccountInactiveReasons(options = {}) {
  options.custom = options.custom || {}; // eslint-disable-line no-param-reassign

  _.extendOwn(options.custom, {
    AccountInactiveReasons: {
      contains: getAccountInactiveReasonsContainsQuery,
      doesnotcontain: getAccountInactiveReasonsDoesNotContainQuery,
    },
  });

  return options;
}
